import { render, staticRenderFns } from "./zombieCarConfig.vue?vue&type=template&id=f46f7128&scoped=true&"
import script from "./zombieCarConfig.vue?vue&type=script&lang=js&"
export * from "./zombieCarConfig.vue?vue&type=script&lang=js&"
import style0 from "./zombieCarConfig.vue?vue&type=style&index=0&id=f46f7128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46f7128",
  null
  
)

export default component.exports